import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const kitchenPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Kitchen Properties',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('kitchen', context.id);
		}
	}
};
